import React from "react";
import { Redirect, Route } from "react-router-dom";
import { connect } from "react-redux";
import { parseUser } from "../../utils/storedUser";
import { dashboardFor } from "./roleRouting";

const mapStateToProps = (state) => ({
    user: state?.Authentication?.user,
    token: state?.Authentication?.token,
});


export const JuryRoute = ({ children, ...props }) => {
    const token = props?.token || localStorage.getItem("Token");
    const rawUser = props?.user || localStorage.getItem("User");
    // parseUser never throws, so the old try/catch around it is gone.
    const parsedUser = parseUser(rawUser);
    const role = parsedUser?.role;

    return (
        <Route
            {...props}
            render={({ location }) =>
                token && role === 'jury' ? (
                    children
                ) : !token ? (
                    <Redirect to={{ pathname: "/" }} />
                ) : (
                    <Redirect to={{ pathname: dashboardFor(role), state: { from: location } }} />
                )
            }
        />
    );
};

export default connect(mapStateToProps)(JuryRoute);
